var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBorder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 330,
    height: 37,
    viewBox: "0 0 330 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_385_458",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -5,
    y: 0,
    width: 340,
    height: 47
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M176.909 2.69891C161.097 4.19926 145.177 5.68417 128.8 7.00347C102.309 9.13961 74.8961 9.14943 47.1728 7.62241C30.576 6.70872 15.3026 5.36416 0.524712 3.84416C-1.06348 3.68135 -2.65846 3.51996 -4.94573 3.28557V4.08276C-4.93668 16.2526 -4.90498 28.4196 -5 40.5866C-5.00226 41.1171 -4.0091 41.4161 -1.33723 41.6954C18.1577 43.7333 38.3744 45.4736 61.2041 46.2975C86.4681 47.2084 110.504 46.6231 133.27 44.7172C150.328 43.2898 166.758 41.6603 183.644 40.1754C216.883 37.2561 250.086 37.374 283.384 40.2231C299.431 41.5971 314.249 43.2519 328.349 45.1031C330.077 45.3291 331.819 45.5536 333.581 45.774C333.767 45.7964 334.113 45.7866 334.937 45.8035V45.0287C334.93 32.908 334.9 20.7901 335 8.66943C335.004 8.09961 334.072 7.71925 331.208 7.40206C316.806 5.80066 302.999 4.03644 288.035 2.59785C269.893 0.853283 251.683 -4.57764e-05 233.462 -4.57764e-05C214.605 -4.57764e-05 195.734 0.913643 176.909 2.69891Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_385_458)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.749 197.965H-50.3926V-157.806H163.749V197.965Z",
    fill: "#008446"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.749 197.965H149.874V-157.806H163.749V197.965Z",
    fill: "#F79028"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.118 197.965H145.154V-157.806H148.118V197.965Z",
    fill: "#00A5E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.267 197.965H138.301V-157.806H141.267V197.965Z",
    fill: "#EE353C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.301 197.965H135.337V-157.806H138.301V197.965Z",
    fill: "#F79028"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.212 197.965H7.27686V-157.806H64.212V197.965Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.2718 197.965H68.4189V-157.806H72.2718V197.965Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.1238 197.965H72.271V-157.806H76.1238V197.965Z",
    fill: "#EE353C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.495 197.965H78.3687V-157.806H90.495V197.965Z",
    fill: "#00A5E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.3369 197.965H78.3687V-157.806H82.3369V197.965Z",
    fill: "#FBEF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.37928 197.965H0.736816V-157.806H3.37928V197.965Z",
    fill: "#FBEF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.06525 197.965H-2.7876V-157.806H1.06525V197.965Z",
    fill: "#EE353C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0645 197.964V-157.807",
    stroke: "#FBEF00",
    strokeWidth: 1.34933,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2754 197.964V-157.807",
    stroke: "#FADE0D",
    strokeWidth: 1.34933,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4878 197.964V-157.807",
    stroke: "#FACF19",
    strokeWidth: 1.34933,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7017 197.964V-157.807",
    stroke: "#F9BF26",
    strokeWidth: 1.34933,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9131 197.964V-157.807",
    stroke: "#F8B02D",
    strokeWidth: 1.34933,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.124 197.964V-157.807",
    stroke: "#F6A132",
    strokeWidth: 1.34933,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3364 197.964V-157.807",
    stroke: "#F49235",
    strokeWidth: 1.34933,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5493 197.964V-157.807",
    stroke: "#F38337",
    strokeWidth: 1.34933,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7617 197.964V-157.807",
    stroke: "#F27339",
    strokeWidth: 1.34933,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9727 197.964V-157.807",
    stroke: "#F0623B",
    strokeWidth: 1.34933,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1841 197.964V-157.807",
    stroke: "#F04D3B",
    strokeWidth: 1.34933,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.397 197.964V-157.807",
    stroke: "#EE353C",
    strokeWidth: 1.34933,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.9521 197.964V-157.807",
    stroke: "#00A650",
    strokeWidth: 1.34933,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4146 197.964V-157.807",
    stroke: "#00954C",
    strokeWidth: 1.34933,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.8745 197.964V-157.807",
    stroke: "#008648",
    strokeWidth: 1.34933,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.334 197.964V-157.807",
    stroke: "#007844",
    strokeWidth: 1.34933,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.795 197.964V-157.807",
    stroke: "#00693F",
    strokeWidth: 1.34933,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.254 197.964V-157.807",
    stroke: "#005C39",
    strokeWidth: 1.34933,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.714 197.964V-157.807",
    stroke: "#094E33",
    strokeWidth: 1.34933,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.174 197.964V-157.807",
    stroke: "#10412D",
    strokeWidth: 1.34933,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.633 197.964V-157.807",
    stroke: "#143426",
    strokeWidth: 1.34933,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.093 197.964V-157.807",
    stroke: "#11271D",
    strokeWidth: 1.34933,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.552 197.964V-157.807",
    stroke: "#0B1712",
    strokeWidth: 1.34933,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.013 197.964V-157.807",
    stroke: "#030505",
    strokeWidth: 1.34933,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4609 197.964V-157.807",
    stroke: "#030505",
    strokeWidth: 1.34933,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1831 197.964V-157.807",
    stroke: "#1A1211",
    strokeWidth: 1.34933,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9028 197.964V-157.807",
    stroke: "#2D1C1A",
    strokeWidth: 1.34933,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.626 197.964V-157.807",
    stroke: "#3E2321",
    strokeWidth: 1.34933,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3472 197.964V-157.807",
    stroke: "#4F2926",
    strokeWidth: 1.34933,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0669 197.964V-157.807",
    stroke: "#612E2B",
    strokeWidth: 1.34933,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.79 197.964V-157.807",
    stroke: "#74332F",
    strokeWidth: 1.34933,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5122 197.964V-157.807",
    stroke: "#893633",
    strokeWidth: 1.34933,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2329 197.964V-157.807",
    stroke: "#9F3836",
    strokeWidth: 1.34933,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9531 197.964V-157.807",
    stroke: "#B73938",
    strokeWidth: 1.34933,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6763 197.964V-157.807",
    stroke: "#CF383A",
    strokeWidth: 1.34933,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.397 197.964V-157.807",
    stroke: "#EE353C",
    strokeWidth: 1.34933,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.822 197.965H163.683V-157.806H377.822V197.965Z",
    fill: "#008446"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.399 197.965H163.683V-157.806H202.399V197.965Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.286 197.965H221.351V-157.806H278.286V197.965Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.345 197.965H282.492V-157.806H286.345V197.965Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.198 197.965H286.345V-157.806H290.198V197.965Z",
    fill: "#EE353C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.568 197.965H292.441V-157.806H304.568V197.965Z",
    fill: "#00A5E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.41 197.965H292.441V-157.806H296.41V197.965Z",
    fill: "#FBEF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.453 197.965H214.811V-157.806H217.453V197.965Z",
    fill: "#FBEF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.285 197.965H207.432V-157.806H211.285V197.965Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.139 197.965H211.286V-157.806H215.139V197.965Z",
    fill: "#EE353C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.108 197.965H163.683V-157.806H168.108V197.965Z",
    fill: "#00A5E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.214 197.965H169.364V-157.806H173.214V197.965Z",
    fill: "#00A5E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.32 197.965H175.044V-157.806H178.32V197.965Z",
    fill: "#00A5E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.429 197.965H180.726V-157.806H183.429V197.965Z",
    fill: "#00A5E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.533 197.965H186.404V-157.806H188.533V197.965Z",
    fill: "#00A5E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.639 197.965H192.084V-157.806H193.639V197.965Z",
    fill: "#00A5E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.745 197.965H197.763V-157.806H198.745V197.965Z",
    fill: "#00A5E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.138 197.964V-157.807",
    stroke: "#FBEF00",
    strokeWidth: 1.34933,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.349 197.964V-157.807",
    stroke: "#FADE0D",
    strokeWidth: 1.34933,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.562 197.964V-157.807",
    stroke: "#FACF19",
    strokeWidth: 1.34933,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.774 197.965V-157.807",
    stroke: "#F9BF26",
    strokeWidth: 1.34933,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.987 197.964V-157.807",
    stroke: "#F8B02D",
    strokeWidth: 1.34933,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.198 197.965V-157.807",
    stroke: "#F6A132",
    strokeWidth: 1.34933,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.411 197.964V-157.807",
    stroke: "#F49235",
    strokeWidth: 1.34933,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.622 197.965V-157.807",
    stroke: "#F38337",
    strokeWidth: 1.34933,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.834 197.964V-157.807",
    stroke: "#F27339",
    strokeWidth: 1.34933,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.046 197.965V-157.807",
    stroke: "#F0623B",
    strokeWidth: 1.34933,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.26 197.964V-157.807",
    stroke: "#F04D3B",
    strokeWidth: 1.34933,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.472 197.964V-157.807",
    stroke: "#EE353C",
    strokeWidth: 1.34933,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.028 197.964V-157.807",
    stroke: "#00A650",
    strokeWidth: 1.34933,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.488 197.964V-157.807",
    stroke: "#00954C",
    strokeWidth: 1.34933,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.948 197.964V-157.807",
    stroke: "#008648",
    strokeWidth: 1.34933,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.409 197.964V-157.807",
    stroke: "#007844",
    strokeWidth: 1.34933,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.868 197.964V-157.807",
    stroke: "#00693F",
    strokeWidth: 1.34933,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.328 197.964V-157.807",
    stroke: "#005C39",
    strokeWidth: 1.34933,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.788 197.965V-157.807",
    stroke: "#094E33",
    strokeWidth: 1.34933,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.535 197.964V-157.807",
    stroke: "#030505",
    strokeWidth: 1.34933,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.257 197.964V-157.807",
    stroke: "#1A1211",
    strokeWidth: 1.34933,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.977 197.964V-157.807",
    stroke: "#2D1C1A",
    strokeWidth: 1.34933,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.699 197.964V-157.807",
    stroke: "#3E2321",
    strokeWidth: 1.34933,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.421 197.964V-157.807",
    stroke: "#4F2926",
    strokeWidth: 1.34933,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.143 197.964V-157.807",
    stroke: "#612E2B",
    strokeWidth: 1.34933,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.863 197.964V-157.807",
    stroke: "#74332F",
    strokeWidth: 1.34933,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.586 197.964V-157.807",
    stroke: "#893633",
    strokeWidth: 1.34933,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.307 197.964V-157.807",
    stroke: "#9F3836",
    strokeWidth: 1.34933,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.027 197.964V-157.807",
    stroke: "#B73938",
    strokeWidth: 1.34933,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.75 197.964V-157.807",
    stroke: "#CF383A",
    strokeWidth: 1.34933,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.472 197.964V-157.807",
    stroke: "#EE353C",
    strokeWidth: 1.34933,
    strokeMiterlimit: 10
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBorder);
export default __webpack_public_path__ + "static/media/border.c38cca2e3d762b75aee717d679e22a50.svg";
export { ForwardRef as ReactComponent };